// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__zsBOI","label":"Radio_label__1L774","checkMark":"Radio_checkMark__1muGG","disabled":"Radio_disabled__3OzxH"};